import { Expose, Type } from 'class-transformer';
import { EventImage, PaginatedEntity } from '@core/entities';
import { SafeUrl } from '@angular/platform-browser';

export class UserContentEventList extends PaginatedEntity {
  @Type(() => UserContentEventEntity)
  events: UserContentEventEntity[];
}

export class UserContentEventEntity {
  id: number;
  description: string;
  @Expose({ name: 'name' })
  title: string;

  imageUrl: SafeUrl | string;

  @Expose({ name: 'event_images' })
  @Type(() => EventImage)
  eventImages: EventImage[];
}
